<template>
    <div id="app">
        <PatientNotes :Mode="'View'" :Type="AppServiceID"/>
    </div>
</template>

<script>
import Vue from 'vue';
import PatientNotes from '@/components/DPEBB/Administrator/PatientNotes.vue'
 
import LayoutDefault from '../../Common/Default/DefaultLayout.vue';

export default {

  data: function (){
        return {
        AppServiceID :'',
        }
    },
    components: { 
        PatientNotes
    },
    created: function() {
        this.AppServiceID = this.$store.getters.GetPodiatryID;
        this.$emit('update:layout', LayoutDefault);
    },    
    beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetPodiatryID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetPodiatryID);
    },

}
</script>

<style>

</style>
